import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useOAuth2 } from '@tasoskakour/react-use-oauth2';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAuthorization } from '../../helpers/api_helper';
import { loginSuccess } from '../../slices/auth/login/reducer';
import * as url from '../../helpers/auth/url_helper';
import config from '../../config';

const LoginButtonMicrosoft = ({color}) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [notExists, setNotExists] = useState(false);

	const { data, loading, error, getAuth } = useOAuth2({
		authorizeUrl: `https://login.microsoftonline.com/${config.oauth_microsoft.REACT_APP_MICROSOFT_TENANT_ID}/oauth2/v2.0/authorize`,
		clientId: config.oauth_microsoft.REACT_APP_MICROSOFT_CLIENT_ID,
		redirectUri: config.oauth_microsoft.REACT_APP_REDIRECT_URL,
		scope: `api://${config.oauth_microsoft.REACT_APP_MICROSOFT_APP_CLIENT_ID}/user_impersonation`,
		responseType: 'code',
		extraQueryParameters: {
			code_challenge:
				config.oauth_microsoft.REACT_APP_MICROSOFT_CODE_CHALLENGE,
			code_challenge_method: 'S256',
			response_mode: 'query',
		},
		exchangeCodeForTokenQuery: {
			url: `${config.api.REACT_APP_SPED_AUTH_API_URL}${url.POST_AZURE_LOGIN}`,
			method: 'POST',
		},
		onSuccess: async response => {
			if (response.access_token) {
				localStorage.setItem('authUser', JSON.stringify(response));
				setAuthorization(response.access_token);
				dispatch(loginSuccess(response));

				if (data.privacy_policy) {
					navigate('/dashboard');
				} else {
					navigate('/privacy-policy');
				}
			} else {
				setNotExists(true);
			}
		},
		onError: async error => {
			console.log(error);
		},
	});

	return (
		<React.Fragment>
			<Button className='btn-label w-50' onClick={getAuth} style={{ backgroundColor: color, borderColor: color }}>
				<i className='ri-windows-fill label-icon align-middle fs-16 me-2'></i>{' '}
				Acceso con Microsoft
			</Button>
			{notExists ? (
				<div className="alert alert-danger alert-dismissible alert-label-icon rounded-label fade show mt-3" role="alert">
					<i className={`${Icons.alert} label-icon`}></i>No se ha encontrado el usuario
				</div>
			) : null}
		</React.Fragment>
	);
};

export default LoginButtonMicrosoft;
